import { connect } from 'react-redux'
import SetTripPassengerModal from 'src/components/trips/modal/SetTripPassengerModal'
import { IStoreState, ITripPassengerDetail } from 'src/types'
import * as actions from '../../../state/actions/trips'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const tripRequest = state.tripRequest || { request: {} }
  const request = tripRequest.request
  return {
    onClose: ownProps.history.goBack,
    history: ownProps.history,
    match: ownProps.match,
    passengerDetails: request.passengerDetails,
    pricingTypes: state.service.pricingType,
    paymentMethods: state.service.paymentMethods,
    rider: state.riders.items[ownProps.match.params.riderId]
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    setTripPassengerDetails: (passengerDetails: ITripPassengerDetail) =>
      dispatch(actions.actionCreators.setTripPassengerDetails(passengerDetails)),
    updateRiderCount: (totalRider: number) => dispatch(actions.actionCreators.updateRiderCount(totalRider)),
    setTripRequestTotalRidersFare: (totalRidersFare: number) =>
      dispatch(actions.actionCreators.setTripRequestTotalRidersFare(totalRidersFare))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetTripPassengerModal)



// WEBPACK FOOTER //
// ./src/containers/trips/modal/SetTripPassengerModal.tsx